import { INSURANCE_TYPES } from "@global/const";

export const modBlocks = {
    description: 'Описание'
}
const modFields = {
    img: {default: '',
        options:  {type: 'imgEdit',
            path:'/storage.public/images/promotions/265x149/',
            width: 500, height: 281, widthBox: 500,
            imgType: 'promotions',
            emptyImgName: 'pic_promo.svg',
            cropBoxDataLeft: 0,
        }
    },
    name: {default: '', options: {type: 'text', output: 'textarea', prefix: 'Название', rules:'required', rows: 5}},
    discount: {default: '', options: {type: 'text', prefix: 'Скидка', suffix: '%', rules:'numeric|max_value:100|min_value:0'}},
    description: {default: '', options: {type: 'html', block:'description', entity: 'promotion'}},
}

export function modDefault()
{
    return _.mapValues(modFields, function (o) {
        return o.default;
    });
}

export function modOptions()
{
    const options = [];
    Object.keys(modFields).forEach(function (key, index) {
        options[index] = modFields[key].options;
        options[index].key = key;
    })
    return options;
}

export function currentYear() {
    return new Date().getFullYear() ?? 2400;
}

